import {Stack} from "@mui/material";
import type {AddressPartResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, F, SummaryPill, SummaryPillRow, rowSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function AddressPartEditor({draft, editing, onChange}: ResolverEditorProps & { draft: AddressPartResolver }) {
    if (!editing) {
        return (
            <Stack direction="column" spacing={0.5} sx={{alignItems: "center", width: "100%"}}>
                <SummaryPillRow>
                    <SummaryPill label="Street Number" value={draft.streetNumber}/>
                    <SummaryPill label="Street Name" value={draft.streetName}/>
                    <SummaryPill label="Apt/Suite" value={draft.aptSuite}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="City" value={draft.city}/>
                    <SummaryPill label="State" value={draft.state}/>
                    <SummaryPill label="Postal Code" value={draft.postalCode}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="Country" value={draft.country}/>
                </SummaryPillRow>
            </Stack>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.streetNumber} placeholder="Street Number" onChange={(v) => upd("streetNumber", v)} width="130px"/>
                <F value={draft.streetName} placeholder="Street Name" onChange={(v) => upd("streetName", v)} width="200px"/>
                <F value={draft.aptSuite} placeholder="Apt / Suite" onChange={(v) => upd("aptSuite", v)} width="120px"/>
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.city} placeholder="City" onChange={(v) => upd("city", v)} width="180px"/>
                <F value={draft.state} placeholder="State" onChange={(v) => upd("state", v)} width="140px"/>
                <F value={draft.postalCode} placeholder="Postal Code" onChange={(v) => upd("postalCode", v)} width="120px"/>
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.country} placeholder="Country" onChange={(v) => upd("country", v)} width="180px"/>
            </Stack>
        </Stack>
    );
}

export default AddressPartEditor;
